<template>
    <section>
        <div class="ibox">
            <div class="ibox-content">
                <div class="table-responsive">
                    <table class="table table-striped table-responsive table-bordered table-hover" id="billingDtTable">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Invioce Number</th>
                                <th>Started</th>
                                <th>Ended</th>
                                <th>Billed Amount</th>
                                <th>Payment Status</th>
                                <th class="text-center"><i class="fa fa-bolt"></i></th>
                            </tr>
                        </thead>
                        <tbody></tbody>
                    </table>
                </div>                                                
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "BillingsHistory",
        props:["selectedRestaurant"],
        data () {
            return {
                dtTable:'',
                selectedBilling:''
            }
        },
        watch:{
            selectedRestaurant(){
                this.dtTable.draw();
            }
        },
        mounted: function(){
            this.populateDatatable();
        },         
        methods:{
            populateDatatable: function(){
            let self = this;
                let processingURL = this.$store.state.mainAppURL + "billings/get_all_billings_of_restaurant_with_pagination";
                self.dtTable = $('#billingDtTable').DataTable({
                    "processing": true,
                    "serverSide": true,
                    "searching": true,
                    autoWidth: false,
                    "dom":'ltipr',
                    "initComplete": function () {
                        var api = this.api();
                        api.column(0).visible( false );
                    },                                    
                    "order": [[0, "desc"]],
                    'language': {
                        'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                            '                <div class="sk-double-bounce1"></div>\n' +
                            '                <div class="sk-double-bounce2"></div>\n' +
                            '              </div>'
                    },
                    "ajax": {
                        url: processingURL,
                        type: "post",
                        data: function ( d ) {
                            Object.assign(d, {restaurant_id: self.selectedRestaurant.id});
                            return JSON.stringify( d );
                        },
                        headers: {
                            "Content-type": "application/json; charset=utf-8"
                        },
                        beforeSend:  (xhr) => {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                        },
                        statusCode: {
                          401: () => {
                            this.updateRefreshTokenInDataTable(this.dtTable);
                          }
                        }
                    },
                    "columnDefs": [
                        { "orderable": false, "targets": [0,1,2,3,4,5] },
                        { 'className': "text-center", 'aTargets': [1,2,3,5]},
                    ],
                    "columns": [
                        { "data": "id","name":"id" },
                        { "data": "invoiceNumber","name":"invoiceNumber" },
                        {
                            "data": "billingStarted","name":"billingStarted",
                            "render": function(data) {
                                return self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A');
                            }
                        },
                        {
                            "data": "billingEnded","name":"billingEnded",
                            "render": function(data){
                                return self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A');
                            }
                        },
                        { "data": "billedAmount","name":"billedAmount" },
                        {
                            "data": "paymentStatus","name":"paymentStatus",
                            "render": function(data, type, row){
                                return "<span class= 'label " + self.$parent.getClass(data) +"'>" + data+"</span>"
                            }
                        },
                        {
                            "data": "actions", "name":"actions",
                            "render": function(data, type, row){
                                return '<a data-id="'+row.id+'" class="btn btn-xs btn-primary view_btn">View</a>';
                            }
                        }
                    ],
                    "drawCallback": function( settings ) {
                        $(".m_tip").tooltip();
                        $(".view_btn").click(function () {
                            let billingId = $(this).attr("data-id");
                            let routeData = self.$router.resolve({path: "/view_invoice"+ "?billingId=" + billingId +"&restaurantId=" + self.selectedRestaurant.id});
                            window.open(routeData.href, '_blank');
                        });
                    },
                    "tableTools": {
                        "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
                    }

                });
            }
        }
        
    }
</script>